import React, {useEffect} from 'react';
import {useCuentas} from "../hooks/useCuentas";
import CardActions from "../../../components/CardActions";
import {Alert, CircularProgress, Stack} from "@mui/material";
import TransferenciaTercerosCuenta from "./TransferenciaTercerosCuenta";
import {QueryStatus} from "../../../../../types";

interface SeccionCapitalMarketDetalleNuevoProps {
  codPais: number
  operacionId: number,
}

function SeccionTransferenciaTercerosCuentas({codPais, operacionId}: SeccionCapitalMarketDetalleNuevoProps) {
  const {cuentas, refetch, status} = useCuentas(operacionId);

  useEffect(() => {
    console.log(cuentas)
  }, [cuentas])

  return (
    <CardActions title={'Cuentas'} icon='mdi:bank-transfer' colapsable>
      {status === QueryStatus.Loading ? (
        <CircularProgress disableShrink sx={{ mt: 6 }} />
      ) : status === QueryStatus.Error ? (
        <Alert severity="error">Se produjo un error al cargar las cuentas.</Alert>
      ) : status === QueryStatus.Success ? (
        !cuentas?.length ? (
          <Alert severity="info">No se encontraron cuentas para esta operación.</Alert>
        ) : (
          <Stack spacing={3}>
            {cuentas.map((cuenta, index) => (
              <TransferenciaTercerosCuenta
                key={index}
                idOperacion={operacionId}
                codPais={codPais}
                cuenta={cuenta}
                refetch={refetch}
                permiteEliminar={false}
                permiteEditar={false}
              />
            ))}
          </Stack>
        )
      ) : null}
    </CardActions>
  );
}

export default SeccionTransferenciaTercerosCuentas;